export const TYPE_DOCUMENT = [
  {
    id: 1,
    descricao: 'CONTRATO DE PRESTAÇÃO DE SERVIÇOS'
  },
  {
    id: 2,
    descricao: 'RECIBO DE VENDA',
  },
  {
    id: 3,
    descricao: 'INTENÇÃO DE AULA COMPARTILHADA'
  }
]
